<template>
  <div class="layout-header">
    <div class="hall-title">{{ platformTitle }}</div>
    <div class="route-step">
      <step-tabs
        :current="currentIndex"
        :tab-list="processList"
        reverse-color
        :before-change="beforeStepChange"
      />
    </div>
  </div>
</template>

<script>
import StepTabs from '@/views/hall/review-hall/components/StepTabs.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'InquiryReviewHallHeader',

  components: { StepTabs },

  props: {
    currentIndex: {
      type: [Number, String],
      default: 0
    },

    processList: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters('company', ['platformTitle'])
  },

  methods: {
    beforeStepChange(index) {
      const tab = this.processList[index]
      this.$emit('changeStep', tab)
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.layout-header {
  width: 100%;
  height: 64px;
  background: $primary-color;
  color: $white-color;
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  padding: 12px 32px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  .hall-title {
    font-size: 20px;
  }
}

.route-step {
  width: 100%;
  height: 64px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>
